"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceName = void 0;
var SpaceName;
(function (SpaceName) {
    SpaceName["ARSIA_MONS"] = "29";
    SpaceName["ASCRAEUS_MONS"] = "14";
    SpaceName["GANYMEDE_COLONY"] = "01";
    SpaceName["NOCTIS_CITY"] = "31";
    SpaceName["PAVONIS_MONS"] = "21";
    SpaceName["PHOBOS_SPACE_HAVEN"] = "02";
    SpaceName["THARSIS_THOLUS"] = "09";
    SpaceName["LUNA_METROPOLIS"] = "70";
    SpaceName["DAWN_CITY"] = "71";
    SpaceName["STRATOPOLIS"] = "72";
    SpaceName["MAXWELL_BASE"] = "73";
    SpaceName["ARSIA_MONS_ELYSIUM"] = "37";
    SpaceName["HECATES_THOLUS"] = "08";
    SpaceName["ELYSIUM_MONS"] = "14";
    SpaceName["OLYMPUS_MONS"] = "20";
    SpaceName["HELLAS_OCEAN_TILE"] = "61";
    SpaceName["STANFORD_TORUS"] = "69";
    SpaceName["MEDUSAE_FOSSAE"] = "33";
    SpaceName["ALBOR_THOLUS"] = "09";
    SpaceName["ANSERIS_MONS"] = "35";
    SpaceName["PINDUS_MONS"] = "43";
    SpaceName["ULYSSES_THOLUS"] = "49";
    SpaceName["VASTITAS_BOREALIS_NORTH_POLE"] = "33";
    SpaceName["ELYSIUM_MONS_VASTITAS_BOREALIS"] = "07";
    SpaceName["ALBA_FOSSAE"] = "12";
    SpaceName["CERANIUS_FOSSAE"] = "21";
    SpaceName["ALBA_MONS"] = "22";
    SpaceName["ALBOR_THOLUS_TERRACIMMERIA"] = "05";
    SpaceName["TYRRHENUS_MONS"] = "21";
    SpaceName["APOLLINARIS_MONS"] = "27";
    SpaceName["HADRIACUS_MONS"] = "38";
})(SpaceName = exports.SpaceName || (exports.SpaceName = {}));
//# sourceMappingURL=SpaceName.js.map